
import Title from "./Title";
import map from "../img/map.png";
export default function Locations() {
    return <>
        <div className="Locations py-sm-4 py-md-5 mt-0 mt-lg-0" >
            <div className="container" >
                <Title mainClass=" d-table m-auto mb-3"
                    titleclass="md heading text-dark text-center w-75 m-auto d-table"
                    title={<>We have more than 500+ Locations ​​around the world!</>}
                />
                <div className="mapArea m-auto d-table mt-4" >
                    <img src={map} className="img-fluid" alt="image" />
                </div>
            </div>
        </div>
    </>
}